<template>
  <!-- Header -->
  <HeaderComponent @expanded="handleExpandedValue"></HeaderComponent>

  <!-- Content -->
  <main :class="['layout-content', { expanded: childValue }]"
        :style="(isMobile)?`min-height: calc(var(--vh) - 6.4rem)`:'min-height:var(--vh)'">
    <div class="btn-back_container" v-if="hasBack">
      <button class="btn-back" @click="goBack">
        <i class="bp-icon-Back btn-back-icon"></i>
        <span class="btn-back-label">volver</span>
      </button>
    </div>
    <slot name="content">
      <!-- Default content if no slot is provided -->
      <p></p>
    </slot>
  </main>
  <!-- Footer -->
  <footer :class="{'expanded': childValue }">
    <FooterComponent></FooterComponent>
  </footer>
</template>

<script setup lang="ts">
import FooterComponent from '@/components/core/Footer/FooterComponent.vue';
import HeaderComponent from '@/components/core/HeaderComponent/HeaderComponent.vue';
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useRouter } from 'vue-router';
import { defineProps } from 'vue';

// eslint-disable-next-line no-unused-vars
const props = defineProps({
  hasBack: {
    type: Boolean,
    default: false,
  },
});

const childValue = ref<boolean>(true);
const router = useRouter();
const isMobile = ref(window.innerWidth <= 768);

const goBack = () => {
  if (window.history.length > 1) {
    router.back();
  } else {
    router.push('/'); // Redirigir a la home si no hay historial previo
  }
};

const handleExpandedValue = (value: string): void => {
  childValue.value = value;
};

const checkHeight = () => {
  isMobile.value = window.innerWidth <= 768;
};

onMounted(() => {
  checkHeight();
  window.addEventListener("resize", checkHeight);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", checkHeight);
});
</script>

<style lang="scss" scoped>
@import 'DefaultLayout';
</style>